import { observer } from 'mobx-react-lite'
import './index.scss'
import XImg from '@assets/svg/x.svg'
import { Context } from '@/index'
import { useContext } from 'react'
import { changeTaskStatus as changeTaskStatusApi } from '@api/task-api';

const ConfirmSubmitTaskModal = observer(({taskId, callGetTask}) => {
    const { modal } = useContext(Context);

    const confirmSubmitTask = () => {
        const object = {
            task_status: 'done'
        }
        changeTaskStatusApi(taskId, object)
        .then(() => {
            callGetTask();
            modal.closeModal();
        })
        .catch((error) => {
            console.log(error);
        })
    }

    return (
        <div className="confirm-submit-task-modal">
            <div className="header-modal">
İşin qəbul edilməsinin təsdiqi
                <div className="x-block" onClick={() => modal.closeModal()}>
                    <img src={XImg} className="x" alt="close"/>
                </div>
            </div>
            <div className="description">
İcraçının texniki tapşırığa uyğun olaraq sifarişin bütün bəndlərini yerinə yetirdiyinə əmin olun.
            </div>
            <div className="row">
                <div className="col-md-6">
                    <button type="button" className="my-button2" onClick={() => modal.closeModal()}>Bağla</button>
                </div>
                <div className="col-md-6">
                    <button type="button" className="my-button" onClick={confirmSubmitTask}>İşi qəbul et</button>
                </div>
            </div>
            
        </div>
    )
})

export { ConfirmSubmitTaskModal }